import { render, staticRenderFns } from "./ItemizerCanvas.vue?vue&type=template&id=bff407b8&scoped=true&"
import script from "./ItemizerCanvas.vue?vue&type=script&lang=js&"
export * from "./ItemizerCanvas.vue?vue&type=script&lang=js&"
import style0 from "./ItemizerCanvas.vue?vue&type=style&index=0&id=bff407b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff407b8",
  null
  
)

export default component.exports